import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layer deletAlt"
}
const _hoisted_2 = { class: "layerBtnArea" }
const _hoisted_3 = {
  key: 1,
  class: "layer deletAlt"
}
const _hoisted_4 = { class: "layerBtnArea" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = {
  class: "tableList",
  style: {"width":"600px"}
}
const _hoisted_7 = ["value", "onChange", "disabled"]
const _hoisted_8 = ["onUpdate:modelValue", "disabled", "onBlur", "onKeyup"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 3,
  class: "mgT05"
}
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "blue bold mgT05" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.ui.layer_etc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "layerMain" }, [
            _createElementVNode("div", { class: "layerMainText" }, [
              _createElementVNode("b", null, "일반 전화"),
              _createTextVNode("는 사용하시는 "),
              _createElementVNode("b", null, "통신사에 [통신서비스 이용증명원] 서류를 발급하신 다음 제출"),
              _createTextVNode("하여야 발신번호를 사용하실 수 있습니다. "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" ※ 통신서비스 이용증명원은 본인 명의의 전화에만 발급하실 수 있습니다. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "blueBtn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {$data.ui.layer_etc = false;})
            }, "확인")
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.ui.layer_del)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "layerMain" }, [
            _createElementVNode("div", { class: "layerMainText" }, [
              _createTextVNode(" 정말 이 발신 번호를 삭제하시겠습니까?"),
              _createElementVNode("br"),
              _createTextVNode("삭제 후 이 발신 번호를 다시 사용하려면"),
              _createElementVNode("br"),
              _createTextVNode(" 다시 인증 절차를 거쳐야 합니다. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "blueBtn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {$options.phone_del();})
            }, "확인"),
            _cache[6] || (_cache[6] = _createTextVNode("  ", -1)),
            _createElementVNode("button", {
              class: "grayBtn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {$options.phone_del_layer(false, '');})
            }, "취소")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("tr", null, [
          _createElementVNode("th", { style: {"width":"100px"} }, "기본 발신번호"),
          _createElementVNode("th", null, "발신 번호"),
          _createElementVNode("th", null, "상태")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.phone_list, (r) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", null, [
              (!r.IS_NEW)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "radio",
                    value: r.PHONE_NO,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.api.def_change.phone_no) = $event)),
                    onChange: ($event: any) => {$options.change_default(r);},
                    disabled: r.SEND_PHON_CNO.substring(0,3) != '010' || r.SEND_APVL_CD != '2' && r.SEND_APVL_CD != '4'
                  }, null, 40, _hoisted_7)), [
                    [_vModelRadio, $data.api.def_change.phone_no]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                ref_for: true,
                ref: "SEND_PHON_CNO",
                "onUpdate:modelValue": ($event: any) => ((r.SEND_PHON_CNO) = $event),
                disabled: !r.IS_NEW,
                onBlur: ($event: any) => ($options.autoPhone($event, r)),
                onKeyup: ($event: any) => ($options.autoPhone($event, r)),
                maxlength: "13"
              }, null, 40, _hoisted_8), [
                [_vModelText, r.SEND_PHON_CNO]
              ])
            ]),
            _createElementVNode("td", null, [
              (r.IS_JSD_ASGN)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("button", { class: "yellowBtn mgR10" }, "증산도 기본번호", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (!r.IS_NEW)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    (r.SEND_APVL_CD !='2' && r.SEND_APVL_CD !='4')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["selectFin mgR10", {ready: r.SEND_APVL_CD =='2' || r.SEND_APVL_CD =='4'}]),
                          onClick: ($event: any) => {$options.phone_cert(r);}
                        }, _toDisplayString(r.SEND_APVL_CDNM), 11, _hoisted_11))
                      : _createCommentVNode("", true),
                    ($data.api.def_change.phone_no != r.PHONE_NO)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "redBtn",
                          onClick: ($event: any) => {$options.phone_del_layer(true, r);}
                        }, "삭제", 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (r.IS_NEW)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "grayBtn mgR10",
                      onClick: ($event: any) => {$options.phone_add(r);}
                    }, "추가", 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              (r.CERT_LAYER)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "mgR05",
                      style: {"width":"95px"},
                      placeholder: "인증번호입력",
                      "onUpdate:modelValue": ($event: any) => ((r.CRTF_TXT) = $event),
                      maxlength: "5"
                    }, null, 8, _hoisted_16), [
                      [
                        _vModelText,
                        r.CRTF_TXT,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "grayBtn",
                      onClick: ($event: any) => {$options.phone_cert_check(r);}
                    }, "인증", 8, _hoisted_17),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("div", _hoisted_18, "남은 시간 : " + _toDisplayString($data.ui.resTimeData), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 256))
      ]),
      _cache[12] || (_cache[12] = _createStaticVNode("<p><h4>발신번호 설정 방법</h4><span class=\"red bold\">1. 휴대폰 번호</span>는 본인 명의의 휴대폰만 등록하실 수 있습니다.<br><span class=\"red bold\">2. 일반전화</span>는 이용 중인 통신사에서 [통신서비스 이용 증명원] 서류를 발급받으신 다음 팩스(02-719-1020)로 보내주셔야 합니다.<br></p><p><h4>발신번호 주의사항</h4> 1. &#39;번호도용문자차단서비스&#39;에 가입된 번호는 문자 발송이 되지 않습니다.<br> 2. 폰발송으로 문자 발송시 등록된 발신번호에 관계없이 <span class=\"red bold\">어플이 설치된 휴대폰 번호로만 발송</span>됩니다.<br> 3. <span class=\"red bold\">1인 1개의 어플만</span> 설치할 수 있습니다. 휴대폰 변경시 기존에 설치된 어플은 삭제하여 주시기 바랍니다.<br>     ※ 각기 다른 스마트폰에서 어플을 설치하여도 1개의 스마트폰에서만 발송이 되므로 발송 오류가 발생할 수 있습니다.<br></p>", 2))
    ])
  ], 64))
}